<template>
    <div class="table-controls-wrapper">
        <el-input
            v-model="searchCompetences"
            :placeholder="$trans('profile_dossier.search_placeholder')"
            clearable
            style="width: 40%"
        >
            <template #suffix>
                <img
                    class="search-icon"
                    src="/media/images/search_gray.png"
                    alt="Search"
                />
            </template>
        </el-input>

        <EditButton
            class="ml-2 edit-button-vue"
            :onClick="redirectToCompetencesEdit"
        />
    </div>

    <EasyDataTable
        :headers="competenceHeaders"
        :items="sortedCompetences"
        :search-value="searchCompetences"
        table-class-name="competence-table"
        :rows-per-page="competenceItems.length"
        :buttons-pagination="false"
    >
        <template #item-action="{ id, is_selected }">
            <el-checkbox
                :key="`checkbox-${id}`"
                :checked="is_selected"
                @change="$emit('toggle', id)"
                :disabled="readOnly"
            />
        </template>

        <template #header-duration>
            <div
                @click="changeSort('duration_in_month')"
                :class="{ active: sortBy === 'duration_in_month' }"
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    padding: 0 8px;
                    cursor: pointer;
                "
            >
                {{ $trans("profile_dossier.duration") }}
                <SortIcons
                    :columnKey="'duration_in_month'"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    style="vertical-align: middle; position: relative; top: 8px"
                />
            </div>
        </template>

        <template #header-name>
            <div
                @click="changeSort('name')"
                :class="{ active: sortBy === 'name' }"
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    padding: 0 8px;
                    cursor: pointer;
                "
            >
                {{ $trans("profile_dossier.competences") }}
                <SortIcons
                    :columnKey="'name'"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    style="vertical-align: middle; position: relative; top: 8px"
                />
            </div>
        </template>

        <template #header-source>
            <div
                @click="changeSort('source')"
                :class="{ active: sortBy === 'source' }"
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    padding: 0 8px;
                    cursor: pointer;
                "
            >
                {{ $trans("profile_dossier.source") || 'Source' }}
                <SortIcons
                    :columnKey="'source'"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    style="vertical-align: middle; position: relative; top: 8px"
                />
            </div>
        </template>
    </EasyDataTable>
</template>

<script>
import EasyDataTable from "vue3-easy-data-table";
import SortIcons from "./SortIcons.vue";
import EditButton from "./../../../WebProfile/Components/EditButton.vue";
export default {
    name: "CompetencesTable",
    components: { 
        EasyDataTable, 
        SortIcons,
        EditButton
    },
    props: {
        competenceItems: {
            type: Array,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        profileId: {
            type: [Number, String],
            required: true,
        },
    },
    emits: ["toggle"],
    data() {
        return {
            searchCompetences: "",
            sortBy: "duration_in_month",
            sortDesc: true,
        };
    },
    computed: {
        competenceHeaders() {
            return [
                {
                    text: this.$trans("profile_dossier.action"),
                    value: "action",
                    width: 25,
                },
                {
                    text: this.$trans("profile_dossier.duration"),
                    value: "duration",
                    sortable: false,
                },
                {
                    text: this.$trans("profile_dossier.competences"),
                    value: "name",
                    sortable: false,
                },
                {
                    text: this.$trans("profile_dossier.source") || "Source",
                    value: "source",
                    sortable: false,
                },
            ];
        },
        sortedCompetences() {
            if (!this.sortBy) return this.competenceItems;

            return [...this.competenceItems].sort((a, b) => {
                let valA = a[this.sortBy];
                let valB = b[this.sortBy];

                if (this.sortBy === "duration_in_month") {
                    valA = Number(valA) || 0;
                    valB = Number(valB) || 0;
                } else {
                    valA = String(valA || "").toLowerCase();
                    valB = String(valB || "").toLowerCase();
                }

                if (valA < valB) return this.sortDesc ? 1 : -1;
                if (valA > valB) return this.sortDesc ? -1 : 1;
                return 0;
            });
        },
    },
    methods: {
        changeSort(column) {
            if (this.sortBy === column) {
                this.sortDesc = !this.sortDesc;
            } else {
                this.sortBy = column;
                this.sortDesc = false;
            }
        },
        redirectToCompetencesEdit() {
            window.open(`/candidates/${this.profileId}/info`, '_blank');
        },
    },
};
</script>

<style scoped>
:deep(.vue3-easy-data-table__main) {
    margin-bottom: unset !important;
}

:deep(.vue3-easy-data-table__main tr td) {
    height: 1px !important;
}

:deep(.vue3-easy-data-table__main tr th),
:deep(.vue3-easy-data-table__main tr td) {
    border: 2px solid #ededed !important;
}

:deep(.vue3-easy-data-table__main tr td) {
    background: #ffffff !important;
    padding: 0.5rem !important;
    line-height: 20px !important;
}

:deep(.vue3-easy-data-table__main tr th) {
    border-top: 0;
    border-bottom: 0;
    background: rgb(237, 237, 237);
    padding: 0 0.5rem;
    color: #3c3c3c;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    font-family: sans-serif;
    border-top: unset;
}

:deep(.vue3-easy-data-table) {
    border: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    background-color: transparent !important;
}

:deep(.vue3-easy-data-table__body tr td:first-child) {
    background-color: #d2e1e5;
}

:deep(.pagination__items-index) {
    display: none !important;
}

:deep(.el-input__prefix) {
    width: 0 !important;
}

:deep(.el-input__wrapper) {
    border-radius: 0 !important;
    height: 37px;
}

:deep(.vue3-easy-data-table__main) {
    background-color: #ededed;
}

:deep(.next-page__click-button .arrow) {
    margin-top: 21px;
    margin-left: 40px;
}

:deep(.vue3-easy-data-table__footer) {
    display: none !important;
}

.searcher {
    height: 40px;
    width: 295px;
    font-weight: 600;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41abc4 !important;
}

:deep(.pagination__rows-per-page) {
    display: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    justify-content: center !important;
}

:deep(.vue3-easy-data-table__body tr:hover td:first-child) {
    background-color: #d2e1e5 !important;
}

:deep(.vue3-easy-data-table__body tr td:first-child) {
    text-align: center !important;
    background-color: #d2e1e5 !important;
}

.competence-table {
    --easy-table-header-font-size: 14px;
    --easy-table-body-row-font-size: 14px;
    --easy-table-border: none;

    --easy-table-body-row-hover-background-color: #fff;
}

:deep(.sortType-icon) {
    display: none !important;
}

.competences-table th {
    position: relative !important;
}

.search-icon {
    width: 16px;
    height: 16px;
    opacity: 0.6;
}

.table-controls-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}

.edit-button-vue {
    width: 24px !important;
    height: 24px !important;
}
</style>